import { cn } from "@/lib/utils";
import * as icons from "lib/icons";
import { HTMLProps, ReactNode, forwardRef } from "react";

type IconProps = Omit<HTMLProps<HTMLElement>, "size"> & {
    name: IconName;
    fallback: ReactNode;
};

const iconCache = new Map();

export const Icon = forwardRef<HTMLElement, IconProps>(
    ({ name, fallback, className, ...props }, ref) => {
        iconCache.set(name, icons[name]);

        const Component = iconCache.get(name)!;

        return (
            <Component
                ref={ref}
                className={cn("[&_*]:fill-current", className)}
                {...props}
            />
        );
    }
);

Icon.displayName = "Icon";
